import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hayfever-oem-login-message',
  templateUrl: './hayfever-oem-login-message.component.html',
  styleUrls: [
    '../style/global.css',
    './hayfever-oem-login-message.component.css',
  ],
})
export class HayfeverOemLoginMessageComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {}

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get isEaj() {
    return this.oemId === 'EAJ';
  }
}
